import { AddPageIcon } from '@/assets/static/icons/add-page-icon';
import { DollarSignCircleIcon } from '@/assets/static/icons/dollar-sign-circle-icon';
import { GearPageIcon } from '@/assets/static/icons/gear-page-icon';
import { HistoryIcon } from '@/assets/static/icons/history-icon';
import Button from '@/components/basicComponents/button';
import { themeVar } from '@/styles/theme';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const zeroStateItems = [
  { icon: <AddPageIcon />, title: 'Add or bulk upload Investors' },
  { icon: <DollarSignCircleIcon />, title: 'Request allocations for desired amount' },
  { icon: <GearPageIcon />, title: 'Provide investor documentation' },
  { icon: <HistoryIcon />, title: 'Check commitment status  at any time' }
];

export const AllocatorZeroState = () => {
  const navigate = useNavigate();

  return (
    <ZeroStateWrapper>
      <ZeroStateTitle>
        <img src="/static/investors-page/missing-mag-glass-graphic.png" draggable="false" alt="No Investors" />
        <div>
          <h2>No Investors Added.</h2>
          <p>You can start by adding an investor below.</p>
        </div>
      </ZeroStateTitle>
      <ZeroStateDevider />
      <ZeroStateSteps>
        {zeroStateItems.map((item, index) => (
          <React.Fragment key={index}>
            <ZeroStateStepItem>
              {item.icon}
              <p>{item.title}</p>
            </ZeroStateStepItem>
            {index !== zeroStateItems.length - 1 && (
              <ZeroStateStepSeparator>
                <div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="21" viewBox="0 0 14 21" fill="none">
                    <path d="M0.856689 2.85001L8.48669 10.5L0.856689 18.15L3.20669 20.5L13.2067 10.5L3.20669 0.5L0.856689 2.85001Z" fill="#ABABAB" />
                  </svg>
                </div>
              </ZeroStateStepSeparator>
            )}
          </React.Fragment>
        ))}
      </ZeroStateSteps>
      <AddButtonWrapper>
        <Button size="lg" onClick={() => navigate(`/investors/create-investor?backToTitle=Allocator`)}>
          Add Investor
        </Button>
      </AddButtonWrapper>
    </ZeroStateWrapper>
  );
};

const ZeroStateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
  max-width: 1100px;
  width: 100%;
  margin: 100px auto;
`;

const ZeroStateTitle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  font-size: 20px;
  padding: 20px 80px;
  border-radius: 20px;
  color: ${themeVar('font.weak')};
  background: ${themeVar('layer.1')};
`;

const ZeroStateDevider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${themeVar('border.base')};
`;

const ZeroStateSteps = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;

const ZeroStateStepItem = styled.div`
  display: flex;
  width: 200px;
  height: 139px;
  padding: 10px;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  gap: 15px;
  color: ${themeVar('font.base')};
  text-align: center;
`;

const ZeroStateStepSeparator = styled.div`
  display: flex;
  width: 40px;
  height: 40px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${themeVar('font.weak')};
  & > div {
    width: 20px;
    height: 12.35px;
    flex-shrink: 0;
  }
`;

const AddButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;
